import React from "react";
import { AuditLogEvent } from "../../../../../models/Entities";
import MergeTable from "../../../../shared/MergeTable";
import { SkeletonLoader } from "@merge-api/merge-javascript-shared";
import { AuditLogsTableRow } from ".";
import EmptyStateWrapper from "../../../../shared/EmptyStateWrapper";

type AuditLogTableProps = {
  auditLogEvents?: AuditLogEvent[];
  isLoading: boolean;
};

const AuditLogTable = ({
  auditLogEvents = [],
  isLoading,
  className,
}: AuditLogTableProps & Pick<React.ComponentProps<"div">, "className">) => {
  return (
    <div className={className}>
      <MergeTable
        hover={false}
        hasMorePaddingOnFirstElement
        header={
          <>
            <th scope="col">User</th>
            <th scope="col">Role</th>
            <th scope="col">Event description</th>
            <th scope="col">IP address</th>
            <th scope="col">Date</th>
          </>
        }
        content={
          isLoading ? (
            Array.from({ length: 8 }).map((_, index) => (
              <tr key={`skeleton-row-${index}`}>
                <td colSpan={5}>
                  {/* 44 is the two-line User cell a loaded row shows (24px h6 + 20px sm) */}
                  <SkeletonLoader height={44} borderRadius={8} fullWidth />
                </td>
              </tr>
            ))
          ) : auditLogEvents.length ? (
            auditLogEvents.map((auditLogEvent) => (
              <AuditLogsTableRow key={auditLogEvent.id} auditLogEvent={auditLogEvent} />
            ))
          ) : (
            <tr>
              <td colSpan={5} className="py-9">
                <EmptyStateWrapper isTable title="No audit trail" />
              </td>
            </tr>
          )
        }
      />
    </div>
  );
};

export default AuditLogTable;
